export const queries = [
  {
    username: "John Doe",
    email: "john.doe@example.com",
    content:
      "The quality is top-notch, and it feels great to support such a talented individual. I highly recommend checking out her merchandise if you're a fan—it's a must-have! 👜",
    timestamp: "2 hours ago",
    likes: 10,
    replies: 0,
  },
  {
    username: "Silvia Kennedy",
    email: "silvia.kennedy@example.com",
    content:
      "I just received my new wallet from Jenny, and I couldn't be happier! The design is stunning, showcasing the Jennys unique style perfectly. ",
    timestamp: "2 hours ago",
    likes: 10,
    replies: 5,
  },
  {
    username: "John Doe",
    email: "john.doe@example.com",
    content: "This is a sample query content.",
    timestamp: "2 hours ago",
    likes: 10,
    replies: 5,
  },
];

export const posts = [
  {
    title: "BTS Member Performance",
    description:
      "Experience the electrifying performance of BTS members as they captivate audiences worldwide. Their dynamic stage presence and synchronized choreography leave fans in awe.",
    mediaType: "image",
    mediaUrl:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRtZj-ea4FbFmqZvEmivZ5EaQwQsC8WfzFj7A&s",
    likes: 10,
    comments: 5,
    timestamp: "2 days ago",
  },
  {
    title: "Next Show",
    description:
      "Get ready for an unforgettable night at the upcoming show, where talent meets creativity. Expect a blend of mesmerizing visuals and powerful performances. ",
    mediaType: "image",
    mediaUrl:
      "https://www.rollingstone.com/wp-content/uploads/2022/04/GettyImages-1239729744.jpg?w=1581&h=1054&crop=1",
    likes: 10,
    comments: 5,
    timestamp: "5 days ago",
  },
  {
    title: "Big News",
    description:
      "Discover the latest updates and exciting announcements that are making waves in the music industry. Stay tuned for groundbreaking news and exclusive insights.",
    mediaType: "image",
    mediaUrl: "https://img.jagrantv.com/webstories/ws4511/1686812304-bts-.jpg",
    likes: 10,
    comments: 5,
    timestamp: "1 week ago",
  },
];

export const reviews = [1, 2, 3];

export const talentPosts = [
  {
    id: 1,
    title: "Post 1",
    description:
      "A coffee call is a quick video chat where you can engage in a one-on-one conversation with someone. It’s a fantastic way to connect, share ideas...",
    data: {
      name: "John Doe",
      username: "john_doe",
      avatar: "https://via.placeholder.com/150",
    },
    mediaType: "image",
    mediaUrl:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRtZj-ea4FbFmqZvEmivZ5EaQwQsC8WfzFj7A&s",
  },
  {
    id: 2,
    title: "Post 2",
    description:
      "A coffee call is a quick video chat where you can engage in a one-on-one conversation with someone. It’s a fantastic way to connect, share ideas...",
    data: {
      name: "Jane Doe",
      username: "jane_doe",
      avatar: "https://via.placeholder.com/150",
    },
    mediaType: "video",
    mediaUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
  },
  {
    id: 3,
    title: "Post 3",
    description:
      "A coffee call is a quick video chat where you can engage in a one-on-one conversation with someone. It’s a fantastic way to connect, share ideas...",
    data: {
      name: "John Doe",
      username: "john_doe",
      avatar: "https://via.placeholder.com/150",
    },
    mediaType: "image",
    mediaUrl:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRtZj-ea4FbFmqZvEmivZ5EaQwQsC8WfzFj7A&s",
  },
  {
    id: 4,
    title: "Post 4",
    description:
      "A coffee call is a quick video chat where you can engage in a one-on-one conversation with someone. It’s a fantastic way to connect, share ideas...",
    data: {
      name: "Jane Doe",
      username: "jane_doe",
      avatar: "https://via.placeholder.com/150",
    },
  },
];
